import { useEffect, useRef } from 'react';

import { WebSocketEntityType } from '@this+that/models';

import { useCalendarStore } from '../../../store/Calendar/useCalendarStore';
import {
  useWebSocket,
  WebSocketEventType,
} from '../../WebSocket/WebSocketContext';

const CALENDAR_EVENTS_SYNC_DEBOUNCE_MS = 1000;

export function useCalendarEventsSync() {
  const { subscribe } = useWebSocket();
  const debounceTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    // Accepting a recurring-series invite or dragging an event in Outlook
    // fires a burst of change notifications; coalesce them into one bump.
    const scheduleBump = () => {
      if (debounceTimeoutRef.current !== null) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(() => {
        debounceTimeoutRef.current = null;
        useCalendarStore.getState().bumpEventsRevision();
      }, CALENDAR_EVENTS_SYNC_DEBOUNCE_MS);
    };

    const unsubscribe = subscribe(
      WebSocketEntityType.CalendarEvent,
      [
        WebSocketEventType.INSERT,
        WebSocketEventType.MODIFY,
        WebSocketEventType.REMOVE,
      ],
      scheduleBump,
    );

    return () => {
      if (debounceTimeoutRef.current !== null) {
        clearTimeout(debounceTimeoutRef.current);
        debounceTimeoutRef.current = null;
      }
      unsubscribe();
    };
  }, [subscribe]);
}
